import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { StockInfoType } from '@kinderlabs-pos/shared-data-type';

export const updateStockInfoAsync =
	(rootUrl: string) => async (updateInfo: UpdateStockInfoRequestType) =>
		(await posAxiosClient.put<StockInfoType>(`${rootUrl}/stock/info`, { ...updateInfo })).data;

type UpdateStockInfoRequestType = Omit<StockInfoType, 'productId' | 'stockQuantity'>;
